<template>
  <div>
    <Location :value="profile.location" @input="$emit('input')" v-if="active" :attach="false" />
  </div>
</template>

<script>
import Location from '@/components/candidate/profile/edit/details/Location'

export default {
  components: { Location },
  props: { profile: { type: Object, required: true }, active: { type: Boolean, default: false } },
}
</script>
